import { Box } from 'styled-system/jsx';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import MainLayout from '@/common/components/layouts/MainLayout';
import DocumentationList from '@/modules/FileDetail/components/documentation/DocumentationList.tsx';

export default () => (
  <MainLayout title="مستندات" header="titleHeader">
    <Documentation />
  </MainLayout>
);

const Documentation = () => {
  return (
    <Box pt="20px">
      <TitleDescription mb="20px">لیست مستندات</TitleDescription>
      <DocumentationList />
    </Box>
  );
};
